import React from 'react';

export interface KpiChartPanelProps {
  title?: string;
  /** Optional class for the title row (e.g. text-center). */
  titleClassName?: string;
  /** Rendered at the end of the title row (e.g. sort / actions). */
  titleEnd?: React.ReactNode;
  children: React.ReactNode;
  className?: string;
  bodyClassName?: string;
  /** Stretch to parent grid cell height (paired charts align). */
  flexFill?: boolean;
}

/** Shared chrome for KPI chart widgets — consistent radius, shadow, and header strip */
const KpiChartPanel: React.FC<KpiChartPanelProps> = ({
  title,
  titleClassName = '',
  titleEnd,
  children,
  className = '',
  bodyClassName = 'px-3 pb-4 pt-4',
  flexFill = false,
}) => (
  <div
    className={`overflow-hidden rounded-xl border border-slate-200/90 bg-white shadow-sm shadow-slate-900/5 ring-1 ring-slate-950/[0.04] ${
      flexFill ? 'flex h-full min-h-[22rem] flex-col' : ''
    } ${className}`.trim()}
  >
    {title ? (
      <div className="relative z-40 shrink-0 border-b border-slate-100 bg-gradient-to-r from-slate-50 via-white to-indigo-50/40 px-4 py-3">
        <span
          className="absolute left-0 top-0 h-full w-1 bg-gradient-to-b from-indigo-500 to-violet-500"
          aria-hidden
        />
        <div className="flex items-start justify-between gap-3 pl-2.5">
          <h3
            className={`min-w-0 flex-1 text-sm font-semibold tracking-tight text-slate-800 ${titleClassName}`.trim()}
          >
            {title}
          </h3>
          {titleEnd ? <div className="shrink-0 pt-0.5">{titleEnd}</div> : null}
        </div>
      </div>
    ) : null}
    <div
      className={`${bodyClassName} ${flexFill ? 'flex min-h-0 flex-1 flex-col' : ''}`.trim()}
    >
      {children}
    </div>
  </div>
);

export default KpiChartPanel;
